import React from "react"
import classes from "./map.module.css"

const Map = () => {
  return (
    <div className={classes.Map}>
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2524.8379129416144!2d-1.8646283839640325!3d50.741495079516646!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4873a1fdee105a6d%3A0x5c23f2c7948921f0!2s339%20Charminster%20Rd%2C%20Bournemouth%20BH8%209QR!5e0!3m2!1sen!2suk!4v1573920737723!5m2!1sen!2suk"
        width="1600"
        height="400"
        frameBorder="0"
        style={{ border: 0 }}
        allowFullScreen=""
      ></iframe>
    </div>
  )
}

export default Map
